import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { getFleetMediaUrl } from "../../../../../api/fleet-management/api";

const VehicleForm = ({
  form,
  validationErrors,
  submitting,
  isEditMode,
  onSubmit,
  onFieldChange,
  onSpecificationsChange,
  onToggleSpecification,
  onImageChange,
  onUploadImage,
  onAddImage,
  onRemoveImage,
  onFeatureChange,
  onAddFeature,
  onRemoveFeature,
  onReset,
  uploadingImageIndex,
  isDeletingMedia,
}) => {
  return (
    <Form onSubmit={onSubmit}>
      <h5 className="mb-3">Basic Details</h5>
      <Row>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Make</Form.Label>
            <Form.Control
              type="text"
              value={form.make}
              onChange={(e) => onFieldChange("make", e.target.value)}
              placeholder="Toyota"
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Model</Form.Label>
            <Form.Control
              type="text"
              value={form.model}
              onChange={(e) => onFieldChange("model", e.target.value)}
              placeholder="Corolla"
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Year</Form.Label>
            <Form.Control
              type="number"
              value={form.year}
              onChange={(e) => onFieldChange("year", e.target.value)}
              placeholder="2022"
              isInvalid={!!validationErrors.year}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.year}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Registration Number</Form.Label>
            <Form.Control
              type="text"
              value={form.registrationNumber}
              onChange={(e) => onFieldChange("registrationNumber", e.target.value)}
              placeholder="LEA-1234"
              isInvalid={!!validationErrors.registrationNumber}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.registrationNumber}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Engine Number</Form.Label>
            <Form.Control
              type="text"
              value={form.engineNumber}
              onChange={(e) => onFieldChange("engineNumber", e.target.value)}
              placeholder="ENG-XYZ"
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Chassis Number</Form.Label>
            <Form.Control
              type="text"
              value={form.chassisNumber}
              onChange={(e) => onFieldChange("chassisNumber", e.target.value)}
              placeholder="CHS-XYZ"
            />
          </Form.Group>
        </Col>

        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Category</Form.Label>
            <Form.Control
              type="text"
              value={form.category}
              onChange={(e) => onFieldChange("category", e.target.value)}
              placeholder="SUV"
              isInvalid={!!validationErrors.category}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.category}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Fuel Type</Form.Label>
            <Form.Select value={form.fuelType} onChange={(e) => onFieldChange("fuelType", e.target.value)}>
              <option value="">Select fuel type</option>
              <option value="petrol">Petrol</option>
              <option value="diesel">Diesel</option>
              <option value="hybrid">Hybrid</option>
              <option value="electric">Electric</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Fuel Tank Capacity</Form.Label>
            <Form.Control
              type="number"
              value={form.fuelTankCapacity}
              onChange={(e) => onFieldChange("fuelTankCapacity", e.target.value)}
              placeholder="45"
              isInvalid={!!validationErrors.fuelTankCapacity}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.fuelTankCapacity}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <h5 className="mb-3 mt-2">Specifications</h5>
      <Row>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Transmission</Form.Label>
            <Form.Select
              value={form.specifications.transmission}
              onChange={(e) => onSpecificationsChange("transmission", e.target.value)}
            >
              <option value="">Select transmission</option>
              <option value="manual">Manual</option>
              <option value="automatic">Automatic</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Seating Capacity</Form.Label>
            <Form.Control
              type="number"
              value={form.specifications.seatingCapacity}
              onChange={(e) => onSpecificationsChange("seatingCapacity", e.target.value)}
              placeholder="4"
              isInvalid={!!validationErrors["specifications.seatingCapacity"]}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors["specifications.seatingCapacity"]}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select value={form.status} onChange={(e) => onFieldChange("status", e.target.value)}>
              <option value="available">Available</option>
              <option value="booked">Booked</option>
              <option value="maintenance">Maintenance</option>
              <option value="inactive">Inactive</option>
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Check
              type="switch"
              id="hasDriver"
              label="Has Driver"
              checked={form.specifications.hasDriver}
              onChange={(e) => onToggleSpecification("hasDriver", e.target.checked)}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Check
              type="switch"
              id="airConditioned"
              label="Air Conditioned"
              checked={form.specifications.airConditioned}
              onChange={(e) => onToggleSpecification("airConditioned", e.target.checked)}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Price</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={form.price}
              onChange={(e) => onFieldChange("price", e.target.value)}
              placeholder="5000"
              isInvalid={!!validationErrors.price}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.price}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <h5 className="mb-3 mt-2">Features</h5>
      {form.features.map((feature, index) => (
        <Row key={`feature-${index}`}>
          <Col md={10}>
            <Form.Group className="mb-2">
              <Form.Control
                type="text"
                value={feature}
                onChange={(e) => onFeatureChange(index, e.target.value)}
                placeholder="Bluetooth"
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Button type="button" variant="outline-danger" className="w-100" onClick={() => onRemoveFeature(index)}>
              Remove
            </Button>
          </Col>
        </Row>
      ))}
      <Button type="button" variant="outline-primary" className="mb-3" onClick={onAddFeature}>
        + Add Feature
      </Button>

      <h5 className="mb-3 mt-2">Images</h5>
      {form.images.map((image, index) => (
        <Row key={`image-${index}`}>
          <Col md={3}>
            <Form.Group className="mb-2">
              <Form.Select value={image.type} onChange={(e) => onImageChange(index, "type", e.target.value)}>
                <option value="exterior">Exterior</option>
                <option value="interior">Interior</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={7}>
            <Form.Group className="mb-2">
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) => onUploadImage(index, e.target.files?.[0])}
              />
            </Form.Group>
            {image.url && (
              <>
                <small className="text-muted d-block mb-2">Uploaded: {image.url}</small>
                <img
                  src={getFleetMediaUrl(image.url)}
                  alt={`${image.type || "vehicle"} preview`}
                  style={{
                    width: "140px",
                    height: "90px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    border: "1px solid #dee2e6",
                    display: "block",
                    marginBottom: "8px",
                  }}
                />
              </>
            )}
          </Col>
          <Col md={2}>
            <Button
              type="button"
              variant="outline-danger"
              className="w-100"
              disabled={uploadingImageIndex === index || isDeletingMedia}
              onClick={() => onRemoveImage(index)}
            >
              {uploadingImageIndex === index ? "Uploading..." : "Remove"}
            </Button>
          </Col>
        </Row>
      ))}
      {form.images.length > 0 && (
        <small className="text-muted d-block mb-2">
          Upload stores relative media URLs (example: /uploads/file-name.png).
        </small>
      )}
      <Button type="button" variant="outline-primary" className="mb-3" onClick={onAddImage}>
        + Add Image
      </Button>

      <div className="d-flex gap-2 mt-2">
        <Button type="submit" disabled={submitting}>
          {submitting ? (
            <>
              <Spinner as="span" animation="border" size="sm" className="me-2" />
              {isEditMode ? "Saving..." : "Creating..."}
            </>
          ) : (
            isEditMode ? "Save Changes" : "Create Vehicle"
          )}
        </Button>
        <Button type="button" variant="light" disabled={submitting} onClick={onReset}>
          Reset
        </Button>
      </div>
    </Form>
  );
};

export default VehicleForm;
